import React from 'react';
import { cn } from '../cn';
/**
 * Filter frame above the table.
 *
 * Common composition: `TableFilterBar` → (inside `children`) `TableFilterGrid` with multiple `TableFilterField`,
 * each field wrapping `TableFilterSearch` or `Select` / `Input` from `form/`.
 * `title` + `actions` (Clear, Export buttons…) share one row on desktop.
 */
export const TableFilterBar = ({ className, children, title, actions, padded = true, }) => {
    const hasHeader = title != null || actions != null;
    return (React.createElement("div", { className: cn('flex flex-col gap-4', padded && 'rounded-lg border border-[color:var(--form-border,rgba(11,18,32,0.12))] bg-[color:var(--table-filter-bg,transparent)] p-4 sm:p-6', className) },
        hasHeader ? (React.createElement("div", { className: "flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between" },
            title != null ? (React.createElement("div", { className: "text-[length:var(--text-body,14px)] font-semibold text-[color:var(--form-fg,#0b1220)]" }, title)) : (React.createElement("span", null)),
            actions != null ? (React.createElement("div", { className: "flex flex-wrap items-center gap-2 sm:justify-end" }, actions)) : null)) : null,
        React.createElement("div", { className: "min-w-0" }, children)));
};
export default TableFilterBar;
